export const REDUCER_NAME = 'SUPER_ADMIN_DASHBOARD'

